export const environment = {
  name: 'staging',
  production: false,
  uat: false,
  staging: true,
  development: false,
  baseUrl: 'https://stg-camiguin-api.tracwater.online', // Sensorwise Develop Server
  portalId: '6a6c16cf0fe4e5d2d84a2f5a',
  portalTypeId: '6895970418f8a8985a2aebe2'
};
